import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getApprovedOrders = async(showNHKOnly = false) => {
    const url = process.env.REACT_APP_API_URL + "/admin/orders?range=[1,1000]&filter=approved" +
        (showNHKOnly ? "&showNHK=true" : "");
    const response = await axios.get(url, { headers: AuthHeader.authHeader()});
    return {data: response.data, count: response.headers["total-items"]};
  };


const getPO = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorders/" + poId, 
        { headers: AuthHeader.authHeader()});
    return response.data;
  }

const getClosedPurchaseOrders = async(page = 1, perPage = 25, search = '', sanmar = 'all', source = 'all', subsiteId = 'all') => {
    console.log("Getting Closed Purchase Orders");
    const params = new URLSearchParams({
        range: JSON.stringify([page, perPage]),
        filter: 'finalized'
    });
    if (search && search.trim() !== '') params.append('search', search.trim());
    if (sanmar && sanmar !== 'all') params.append('sanmar', sanmar);
    if (source && source !== 'all') params.append('source', source);
    if (subsiteId && subsiteId !== 'all') params.append('subsiteId', subsiteId);
    const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/purchaseorders?" + params.toString(),
        { headers: AuthHeader.authHeader() }
    );
    return {data: response.data, count: response.headers["total-items"]};
  }

  const submitToSanmar = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/submitToSanmar/" + poId, 
        { headers: AuthHeader.authHeader()});
    return response.data;
  }

  const submitPreflightToSanmar = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/submitPreflightToSanmar/" + poId,
        { headers: AuthHeader.authHeader()});
    return response.data;
  }

  const submitToSands = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/submitToSands/" + poId,
        { headers: AuthHeader.authHeader()});
    return response.data;
  }

  const generateXLS = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/generateXLS/" + poId, 
        { headers: AuthHeader.authHeader()});
    return response.data;
  }
  const getClosedPurchaseOrder = async(poId) => {
      
      const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorderdetails/" + poId, 
          { headers: AuthHeader.authHeader()});
      return response.data;
    }

const PurchaseOrderService = {
    getApprovedOrders,
    getClosedPurchaseOrders,
    getClosedPurchaseOrder,
    getPO,
    submitToSanmar,
    submitPreflightToSanmar,
    submitToSands,
    generateXLS
};
export default PurchaseOrderService;